import { render } from "./TheNavigation.vue?vue&type=template&id=0a1ea91e"
const script = {}

import exportComponent from "/codebuild/output/src2249199459/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__